import React from 'react';
import { get } from 'lodash';

import { colorByIndex } from 'legacy/main/components/common/charts/chartUtils';

import StyledTable from './components/StyledTable';
import Dot from 'components/Dot';

const Table = ({ headers, rows, totals, showNonGuaranteed }) => {
    /**
     * Render a row in the table. If an index is provided, it will rendered
     * a coloured dot in front of the label
     */
    const renderRow = (row, index) => (
        <tr key={index}>
            {headers.map(({ key, nonGuaranteedValueKey, formatter }, headerIndex) => {
                const guaranteedValue = formatter(get(row, key));
                const nonGuaranteedValue = formatter(get(row, nonGuaranteedValueKey));
                return (
                    <td key={key}>
                        <div>
                            {headerIndex === 0 && index !== undefined && <Dot colour={colorByIndex(index)} />}
                            {guaranteedValue}
                        </div>
                        {showNonGuaranteed && nonGuaranteedValueKey && (
                            <div className="nonGuaranteedCell">{nonGuaranteedValue}</div>
                        )}
                    </td>
                );
            })}
        </tr>
    );

    const header = (
        <thead>
            <tr>
                {headers.map((row) => (
                    <th key={row.label}>{row.label}</th>
                ))}
            </tr>
        </thead>
    );

    return (
        <StyledTable showbordersbetweenrows>
            {header}
            <tfoot>{renderRow(totals)}</tfoot>
            <tbody>{rows.map((row, index) => renderRow(row, index))}</tbody>
        </StyledTable>
    );
};

export default Table;
